<template>
  <!-- 班级课表 -->
  <div class="my-course">
    <van-list v-model="loading" :finished="finished" :finished-text="finishText" @load="handleGetData">
      <ul class="course-menu" v-if="courseList.length > 0">
        <li class="menu-li" v-for="(item, index) in courseList" :key="index">
          <img src="@/assets/images/grade/current.png" class="isCur" v-if="item && item.atPresent" alt="">
          <div class="menu-li-head " :class="item.isDropDown ? 'li-main-br' : ''">
            <div class="li-head" @click="handleClassDropDown(item, index)">
              <p class="courseName">{{ item && item.templateName }}</p>
              <div class="icon-down">
                <img src="@/assets/images/grade/drop-up.png" alt="" class="icon-down" v-if="item && item.isDropDown"/>
                <img src="@/assets/images/grade/drop-down.png" alt="" class="icon-down" v-else/>
              </div>
            </div>
            <div class="li-main">
              <div class="main-left">
                <img src="@/assets/images/grade/delete.png" alt="" v-if="!item.atPresent"
                     @click.stop="handleDeleteCourse(item, index)">
              </div>
              <ul class="main-menu">
                <li class="time-data">
                  模版导入时间: {{ $moment(parseInt(item.importTime)).format('YYYY.MM.DD') }}
                  课表开始时间: {{ $moment(parseInt(item.courseStartTime)).format('YYYY.MM.DD') }}
                </li>
                <li class="main-li">
                  <i class="icon-ill"></i>
                  <p class="ill-title">{{ item && item.disease }}</p>
                </li>
                <li class="main-li">
                  <i class="icon-new"></i>
                  <p class="ill-title">{{ item && item.newTechnology }}</p>
                </li>
              </ul>
            </div>
            <template v-if="!item.isDropDown">
              <div class="li-week" v-for="(aitem, aindex) in item.weeks" :key="aindex">
                <div class="week-left">
                  <p class="week-title">week 0{{ aitem && aitem.week }}</p>
                </div>
              </div>
            </template>
          </div>
          <template v-if="item && item.isDropDown">
            <div class="week-box" v-for="(aitem, aindex) in  item.weeks" :key="aindex"
                 @click.stop="handleCourseDorpDown(aitem, index, aindex)">
              <div class="li-week">
                <div class="week-left">
                  <p class="week-title">week 0{{ aitem && aitem.week }}</p>
                </div>
                <div class="week-right">
                  <p class="down-title">
                    {{ aitem.isSwitch ? '收起' : '展开' }}
                  </p>
                  <img src="@/assets/images/grade/drop-up.png" alt="" class="icon-down" v-if="aitem.isSwitch"/>
                  <img src="@/assets/images/grade/drop-down.png" alt="" class="icon-down" v-else/>
                </div>
              </div>
              <template v-if="aitem.isSwitch">
                <div class="day-box" v-if="aitem.templatesContent.length">
                  <div class="day-item" v-for="(acc, cindex) in aitem.templatesContent" :key="cindex">
                    <img src="@/assets/images/grade/icon-doast.png" alt="" class="icon-doast"/>
                    <div class="day-item-box">
                      <p class="day-num">Day{{ acc.day }}</p>
                      <div class="day-main" v-for="(item_course, index_course) in acc.docuCourseCase"
                           :key="index_course">
                        <p class="box-title">{{ item_course.title }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="empty-block" v-else>
                  <img src="@/assets/images/zone/img18.png" class="empty-img" alt=""/>
                  <div class="empty-txt">暂无内容</div>
                </div>
              </template>
            </div>
          </template>
        </li>
      </ul>
      <div class="empty-block" v-else-if="isNone">
        <img src="@/assets/images/zone/img18.png" class="empty-img" alt=""/>
        <div class="empty-txt">暂无内容</div>
      </div>
    </van-list>
    <custom-dialog
      :visible.sync="cDialog.visible"
      @cancel="cDialog.cancel"
      @confirm="cDialog.confirm"
      @close="cDialog.close"
      v-bind="cDialog"
    >
      <div class="txts">{{ cDialog.content }}</div>
    </custom-dialog>
  </div>
</template>

<script>
import withRouteTracking from '@/utils/withRouteTracking'
import {deleteTemplatesHistory, templatesHistory} from '../../api/grade'
import CustomDialog from '@/views/cartoJourney/components/CustomDialog.vue'

const UserProfile = {
  data() {
    return {
      cDialog: {
        title: '标题',
        visible: false,
        content: '是否删除?',
        confirm: () => {
        },
        cancel: () => {
        },
        close: () => {
        },
      },
      courseList: [],
      loading: false,
      finished: false,
      pageObj: {
        pageNum: 1,
        pageSize: 10
      },
      isNone: false,
      finishText: '没有更多了'
    }
  },
  mounted() {
  },
  components: {
    CustomDialog
  },
  computed: {
    classId() {
      return this.$route.query.classId
    }
  },
  methods: {
    async handleGetData() {
      try {
        const res = await templatesHistory(Object.assign({}, this.pageObj, {classId: this.classId}))
        if (res) {
          if (res.code !== 0 || !res.data || !res.data.list) {
            this.loading = false
            this.finished = true
            return false
          }
          this.loading = false
          res.data.list.map(item => {
            item.isDropDown = false
            if (item.weeks && item.weeks.length > 0) {
              item.weeks = item.weeks.map(itm => {
                itm.isSwitch = false
                return itm
              })
            }
            return item
          })
          if (res.data.list.length < this.pageObj.pageSize) {
            this.finished = true
          }
          if (res.code === 0 && res.data.list) {
            this.courseList = this.courseList.concat(res.data.list)
          }
          this.pageObj.pageNum++
          if (this.courseList.length === 0) {
            this.isNone = true
            this.finishText = ''
          }
        }
      } catch (e) {
        throw e
      } finally {
        this.$toast.clear()
      }
    },
    handleDeleteCourse(item) {
      this.cDialog.visible = true
      this.cDialog.confirm = async () => {
        try {
          const res = await deleteTemplatesHistory({
            classId: this.classId,
            versionNumber: item.versionNumber
          })
          if (res.code === 0) {
            this.$toast('删除成功')
            this.courseList.splice(this.courseList.findIndex(itm => itm.versionNumber === item.versionNumber), 1)
            if (this.courseList.length === 0) {
              this.isNone = true
              this.finishText = ''
            }
          }
        } catch (e) {
          throw e
        }
      }
    },
    handleGo() {
      this.$router.go(-1)
    },
    // 下拉展开
    handleClassDropDown(item, index) {
      this.courseList[index].isDropDown = !this.courseList[index].isDropDown
    },
    // 星期收起展开
    handleCourseDorpDown(item, index, aindex) {
      this.courseList[index].weeks[aindex].isSwitch = !this.courseList[index].weeks[aindex].isSwitch
    },
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.my-course {
  position: relative;
  background: #F9F8F7;
  min-height: 100vh;
  padding: 12px 10px 16px;
  box-sizing: border-box;
  z-index: 2;
  display: flex;
  flex-direction: column;

  .course-menu {
    // height: calc(100vh - 80px);
    // overflow-y: scroll;
    list-style: none;
    position: relative;
    width: 100%;
    min-height: 114px;
    border-radius: 12px;

    .menu-li {
      margin-bottom: 10px;
      position: relative;
      background: #FFFFFF;
      border-radius: 12px;

      .isCur {
        position: absolute;
        width: 40px;
        left: 0;
        top: 0;
      }

      .menu-li-head {
        padding: 10px 18px 10px 8px;

        .li-head {
          display: flex;
          align-items: center;

          .courseName {
            flex: 1;
            margin-left: 28px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 600;
            font-size: 14px;
            color: #282828;
            position: relative;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            z-index: 2;
          }

          .icon-down {
            width: 13px;
            height: 7px;
            margin-right: 4px;
            display: block;
          }
        }

        .li-main {
          position: relative;
          display: flex;
          margin-top: 4px;

          .main-left {
            width: 20px;
            margin-right: 8px;

            img {
              width: 20px;
              cursor: pointer;
            }
          }

          .main-menu {
            flex: 1;
            display: flex;

            flex-direction: column;
            position: relative;

            .main-li {
              display: flex;
              // align-items: center;
              position: relative;

              .icon-ill {
                background: url('~@/assets/images/grade/icon-illness2.png') no-repeat center center / 100% 100%;
                width: 24px;
                height: 17px;
                margin-right: 4px;
                display: block;
              }

              .ill-title {
                flex: 1;
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                font-size: 12px;
                color: #000000;
                overflow: hidden;
              }

              .icon-new {
                background: url('~@/assets/images/grade/icon-new-technology.png') no-repeat center center / 100% 100%;
                width: 36px;
                height: 17px;
                margin-right: 4px;
              }
            }

            .time-data {
              color: #6C7480;
              font-size: 12px;
            }
          }
        }
      }

      .li-main-br {
        border-bottom: 1px solid #F0F1F6;
      }

      .li-week {
        background: url("~@/assets/images/grade/class-bg.png") no-repeat center center / 100% 100%;
        width: calc(100% - 28px);
        height: 17px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        margin-left: 28px;
        box-sizing: border-box;

        .week-left {
          background: url("~@/assets/images/grade/icon-week.png") no-repeat center center / 100% 100%;
          width: 63px;
          height: 20px;
          padding: 0 5px;
          display: flex;
          align-items: center;

          .week-title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 600;
            font-size: 12px;
            color: #FFFFFF;
          }

        }

        .week-right {
          position: relative;
          display: flex;
          align-items: center;

          .down-title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 12px;
            color: #000000;
            margin-right: 6px;
          }

          .icon-down {
            width: 11px;
            height: 5px;

          }
        }
      }

      .week-box {
        position: relative;
        padding: 8px 8px 12px 8px;

        .day-box {
          position: relative;

          // min-height: 200px;
          &::before {
            content: "";
            position: absolute;
            border-left: 1px dashed #EB1700;
            left: 14px;
            top: 0;
            width: 1px;
            height: 100%;
          }

          .day-item {
            display: flex;
            flex-direction: column;
            position: relative;
            margin-top: 10px;

            .icon-doast {
              position: absolute;
              left: 8px;
              top: 0;
              width: 13px;
              height: 13px;
            }

            .day-item-box {
              position: relative;
              padding: 0 22px 0 24px;

              .day-num {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                font-size: 14px;
                color: #EB1700;
                margin-bottom: 2px;
              }

              .day-main {
                // height: 40px;
                background: #F2F7FA;
                border-radius: 4px;
                padding: 8px 11px;
                box-sizing: border-box;
                margin-bottom: 10px;

                .box-title {
                  position: relative;
                  font-family: Source Han Sans CN, Source Han Sans CN;
                  font-weight: 400;
                  font-size: 14px;
                  color: #000000;
                }
              }
            }

            .day-num {
            }
          }
        }
      }
    }
  }

}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  position: relative;
  top: 250px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/classHistoryCource.vue